/**
 * App.tsx - Main Application Component
 *
 * Routes (React Router v6):
 * /login      — Login page (redirects to /admin if already authenticated)
 * /admin/*    — Protected admin dashboard
 * /*          — Redirects to /admin
 */

import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import AdminLayout from './components/Layout/AdminLayout';
import LoginModal from './components/Auth/LoginModal';
import ToastContainer from './components/Toast/ToastContainer';
import './App.css';

function RequireAuth({ children }: { children: React.ReactElement }) {
  const token = localStorage.getItem('oni_token');
  const location = useLocation();
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

function RedirectIfAuthed({ children }: { children: React.ReactElement }) {
  const token = localStorage.getItem('oni_token');
  if (token) {
    return <Navigate to="/admin" replace />;
  }
  return children;
}

const App: React.FC = () => {
  return (
    <>
      <ToastContainer />
      <Routes>
        {/* Login page */}
        <Route
          path="/login"
          element={
            <RedirectIfAuthed>
              <LoginModal onClose={() => {}} onLogin={() => {}} />
            </RedirectIfAuthed>
          }
        />

        {/* Protected admin dashboard */}
        <Route
          path="/admin/*"
          element={
            <RequireAuth>
              <AdminLayout />
            </RequireAuth>
          }
        />

        {/* Everything else → admin */}
        <Route path="/*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </>
  );
};

export default App;